const eventFieldName = '__logtimeEventFlag__';

export function addFlag(event: Event) {
  event[eventFieldName] = true;
}

export function checkFlag(event: Event): boolean {
  return event[eventFieldName];
}
